import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';

import './UserManagement.scss';

import commonConstant from '../../common/_commonConstant';
import { getCookieToken } from '../../common/_commonFunction';

import {
  Badges,
  dateDDMMYYFormat,
  DatePicker,
  dateYYYYMMDD,
  filterUser,
  history,
  InputWithIcon,
  isAdmin,
  isNotDuplicateFilter,
  isSuperAdmin,
  Table,
  validateAlpha,
  validateMultiTelNumber,
  validateNumber,
  validateToShowDash,
  buildingID,
} from '../../helpers';
import { Loading, UserManage } from '../../components';
import { fetchGetBuildingByBuildingID, fetchGetUsers } from '../../actions';

const columnHeader = [
  { 'label': 'Name', 'className': 'name', 'sort': true, 'key': 'name' },
  { 'label': 'User Role', 'className': 'role', 'sort': true, 'key': 'user-role' },
  { 'label': 'Username', 'className': 'username', 'sort': false, 'key': '' },
  { 'label': 'Tel', 'className': 'tel', 'sort': false, 'key': '' },
  { 'label': 'Email', 'className': 'email', 'sort': false, 'key': '' },
  { 'label': 'Date created', 'className': 'created-date', 'sort': true, 'key': 'user-created-date' },
  {
    'label': '',
    'className': 'user-edit',
    'sort': false,
    'key': '',
    'icon': true,
    'iconClassName': 'icon icon-edit',
    'keyFuncName': 'displayEditModal',
  },
  {
    'label': '',
    'className': 'user-reset',
    'sort': false,
    'key': '',
    'icon': true,
    'iconClassName': 'icon icon-password',
    'keyFuncName': 'displayResetModal',
  },
];

class UserManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'pageSize': commonConstant.defaultPageSize,
      'pageNumber': 1,
      'sort': commonConstant.defaultSortUserManagement,
      'selectTypeDate': 5,
      'fromDate': '',
      'toDate': '',
      'isOpen': false,
      'action': '',
      'userRole': '',
      'nameInput': '',
      'mobilePhoneInput': '',
      'mobilePhoneInputError': false,
      'userEdit': null,
      'filter': [],
      'filterError': false,
    };
    this.function = {
      'displayEditModal': this.handleDisplayEditModal,
      'displayResetModal': this.handleDisplayResetModal,
    };
    this.passFuncBody = [
      data => validateToShowDash(JSON.parse(data.userProfile).name),
      data => validateToShowDash(data.userRole.userRoleName),
      data => validateToShowDash(data.userName),
      data => validateToShowDash(JSON.parse(data.userProfile).mobilePhone),
      data => validateToShowDash(data.userEmail),
      data => validateToShowDash(dateDDMMYYFormat(data.createdAt)),
      () => '',
      () => '',
    ];
    if (!getCookieToken()) {
      return history.push(commonConstant.pathLogout);
    } else if (props.getProfile && (!isAdmin(props.getProfile) || (isAdmin(props.getProfile) && props.match.params.buildingID !== buildingID(props.getProfile)))) {
      return history.push(commonConstant.pathCheckRedirect);
    } else if (!props.getBuildingByRefNo) {
      props.dispatch(fetchGetBuildingByBuildingID(props.match.params.buildingID));
    }
  }

  UNSAFE_componentWillMount() {
    this.handleClearState();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { getProfile, match } = this.props;

    if ((nextProps.getProfile && nextProps.getProfile !== getProfile) || (nextProps.match.url !== match.url && nextProps.getProfile)) {
      if ((!isAdmin(nextProps.getProfile) || (isAdmin(nextProps.getProfile) && nextProps.match.params.buildingID !== buildingID(nextProps.getProfile)))) {
        return history.push(commonConstant.pathCheckRedirect);
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { createUser, updateUser } = this.props;
    const { userRole, sort, pageSize, pageNumber, fromDate, toDate, filter } = this.state;

    if (createUser.status === 200 && createUser.data !== prevProps.createUser.data && createUser.type === commonConstant.CREATE_USER_SUCCESS) {
      this.setState({
        'pageSize': commonConstant.defaultPageSize,
        'pageNumber': 1,
        'sort': commonConstant.defaultSortUserManagement,
        'filter': [],
        'selectTypeDate': 5,
        'fromDate': '',
        'toDate': '',
        'userRole': '',
      });
      this.props.dispatch(fetchGetUsers(
        this.props.match.params.buildingRefNo,
        null,
        null,
        null,
        commonConstant.defaultSortUserManagement.key,
        commonConstant.defaultSortUserManagement.sort ? 'descending' : 'ascending',
        null,
        null,
        commonConstant.defaultPageSize.value,
        0,
      ));
    } else if (updateUser.status === 200 && updateUser.data !== prevProps.updateUser.data && updateUser.type === commonConstant.UPDATE_USER_SUCCESS) {
      return this.props.dispatch(fetchGetUsers(
        this.props.match.params.buildingRefNo,
        filterUser('name', filter),
        filterUser('mobilePhone', filter),
        userRole ? userRole : null,
        sort.key,
        sort.sort ? 'descending' : 'ascending',
        fromDate ? dateYYYYMMDD(fromDate) : null,
        toDate ? dateYYYYMMDD(toDate) : null,
        pageSize.value,
        (pageSize.value * pageNumber) - pageSize.value >= 0 ? (pageSize.value * pageNumber) - pageSize.value : 0,
      ));
    }
  }

  handleActiveType = key => key === this.state.userRole ? ' active' : '';

  handleInput = event => {
    if (event.target.value.length === 0) {
      return this.setState({ 'nameInput': '', 'mobilePhoneInput': '', 'mobilePhoneInputError': false, 'filterError': false });
    } else if (validateNumber(event.target.value)) {
      return this.setState({ 'mobilePhoneInput': event.target.value, 'mobilePhoneInputError': false, 'filterError': false });
    } else if (validateAlpha(event.target.value)) {
      return this.setState({ 'nameInput': event.target.value, 'filterError': false });
    }
  }

  handleKeyPress = event => {
    const { nameInput, mobilePhoneInput, name, mobilePhone, filter } = this.state;

    if (event.key === 'Enter') {
      if (isNotDuplicateFilter(event.target.value, filter)) {
        if (nameInput && nameInput !== name) {
          this.setState({ 'nameInput': '', 'filter': [...filter, { 'label': event.target.value, 'type': 'name' }] });
          return this.handleSearchUser([...filter, { 'label': event.target.value, 'type': 'name' }]);
        } else if (mobilePhoneInput && mobilePhoneInput !== mobilePhone) {
          if (validateMultiTelNumber(mobilePhoneInput)) {
            this.setState({ 'mobilePhoneInput': '', 'filter': [...filter, { 'label': event.target.value, 'type': 'mobilePhone' }] });
            return this.handleSearchUser([...filter, { 'label': event.target.value, 'type': 'mobilePhone' }]);
          }
          return this.setState({ 'mobilePhoneInputError': true });
        } else if (nameInput.length === 0 && mobilePhoneInput.length === 0) {
          return this.handleSearchUser(null);
        }
      }
      return this.setState({ 'filterError': true });
    }
  }

  handleSearchUser = value => {
    const { sort, fromDate, toDate, userRole, filter } = this.state;

    this.setState({ 'pageNumber': 1, 'pageSize': commonConstant.defaultPageSize });
    return this.props.dispatch(fetchGetUsers(
      this.props.match.params.buildingRefNo,
      filterUser('name', value ? value : filter),
      filterUser('mobilePhone', value ? value : filter),
      userRole,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
      fromDate ? dateYYYYMMDD(fromDate) : null,
      toDate ? dateYYYYMMDD(toDate) : null,
      commonConstant.defaultPageSize.value,
      0,
    ));
  }

  handleSelectDate = (fromDate, toDate, selectTypeDate) => {
    const { sort, userRole, filter } = this.state;

    this.setState({ fromDate, toDate, selectTypeDate, 'loading': true, 'pageSize': commonConstant.defaultPageSize, 'pageNumber': 1, 'filterError': false });

    return this.props.dispatch(fetchGetUsers(
      this.props.match.params.buildingRefNo,
      filterUser('name', filter),
      filterUser('mobilePhone', filter),
      userRole ? userRole : null,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
      fromDate ? dateYYYYMMDD(fromDate) : null,
      toDate ? dateYYYYMMDD(toDate) : null,
      commonConstant.defaultPageSize.value,
      0,
    ));
  }

  handlePageChange = pageNumber => {
    const { fromDate, toDate, pageSize, sort, userRole, filter } = this.state;

    this.setState({ pageNumber, 'loading': true, 'filterError': false });

    return this.props.dispatch(fetchGetUsers(
      this.props.match.params.buildingRefNo,
      filterUser('name', filter),
      filterUser('mobilePhone', filter),
      userRole ? userRole : null,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
      fromDate ? dateYYYYMMDD(fromDate) : null,
      toDate ? dateYYYYMMDD(toDate) : null,
      pageSize.value,
      (pageSize.value * pageNumber) - pageSize.value >= 0 ? (pageSize.value * pageNumber) - pageSize.value : 0,
    ));
  }

  handleSort = sort => {
    const { fromDate, toDate, pageSize, pageNumber, userRole, filter } = this.state;

    this.setState({ sort, 'loading': true });

    return this.props.dispatch(fetchGetUsers(
      this.props.match.params.buildingRefNo,
      filterUser('name', filter),
      filterUser('mobilePhone', filter),
      userRole ? userRole : null,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
      fromDate ? dateYYYYMMDD(fromDate) : null,
      toDate ? dateYYYYMMDD(toDate) : null,
      pageSize.value,
      (pageSize.value * pageNumber) - pageSize.value >= 0 ? (pageSize.value * pageNumber) - pageSize.value : 0,
    ));
  }

  handlePageSize = pageSize => {
    const { fromDate, toDate, sort, userRole, filter } = this.state;

    this.setState({ pageSize, 'pageNumber': 1, 'loading': true, 'filterError': false });
    return this.props.dispatch(fetchGetUsers(
      this.props.match.params.buildingRefNo,
      filterUser('name', filter),
      filterUser('mobilePhone', filter),
      userRole ? userRole : null,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
      fromDate ? dateYYYYMMDD(fromDate) : null,
      toDate ? dateYYYYMMDD(toDate) : null,
      pageSize.value,
      0,
    ));
  }

  handleSelectUserRole = newUserRole => {
    const { sort, fromDate, toDate, pageSize, userRole, filter } = this.state;

    if (userRole !== newUserRole) {
      this.setState({ 'userRole': newUserRole, 'loading': true, 'filterError': false });
      return this.props.dispatch(fetchGetUsers(
        this.props.match.params.buildingRefNo,
        filterUser('name', filter),
        filterUser('mobilePhone', filter),
        newUserRole,
        sort.key,
        sort.sort ? 'descending' : 'ascending',
        fromDate ? dateYYYYMMDD(fromDate) : null,
        toDate ? dateYYYYMMDD(toDate) : null,
        pageSize.value,
        0,
      ));
    }
  }

  handleRemoveFilter = index => {
    const { filter, userRole, sort, fromDate, toDate } = this.state;

    filter.splice(index, 1);
    this.setState({ filter, 'pageSize': commonConstant.defaultPageSize, 'filterError': false });
    return this.props.dispatch(fetchGetUsers(
      this.props.match.params.buildingRefNo,
      filterUser('name', filter),
      filterUser('mobilePhone', filter),
      userRole,
      sort.key,
      sort.sort ? 'descending' : 'ascending',
      fromDate ? dateYYYYMMDD(fromDate) : null,
      toDate ? dateYYYYMMDD(toDate) : null,
      commonConstant.defaultPageSize.value,
      0,
    ));
  }

  handleDisplayModal = (action, userEdit) => this.setState({ 'isOpen': true, action, userEdit, 'filterError': false })

  handleDisplayEditModal = user => this.setState({ 'isOpen': true, 'action': 'EDIT', 'userEdit': user, 'filterError': false });

  handleDisplayResetModal = user => this.setState({ 'isOpen': true, 'action': 'RESET', 'userEdit': user, 'filterError': false });

  handleCloseModal = () => this.setState({ 'isOpen': false })

  handleClearState = nextProps => {
    const props = nextProps ? nextProps : this.props;

    this.setState({
      'pageSize': commonConstant.defaultPageSize,
      'pageNumber': 1,
      'sort': commonConstant.defaultSortUserManagement,
      'filter': [],
      'selectTypeDate': 5,
      'fromDate': '',
      'toDate': '',
      'isOpen': false,
      'action': '',
      'userRole': '',
    });
    return this.props.dispatch(fetchGetUsers(
      props.match.params.buildingRefNo,
      null,
      null,
      null,
      commonConstant.defaultSortUserManagement.key,
      commonConstant.defaultSortUserManagement.sort ? 'descending' : 'ascending',
      null,
      null,
      commonConstant.defaultPageSize.value,
      0,
    ));
  }

  render() {
    const {
      pageSize, pageNumber, sort, filter, nameInput, mobilePhoneInput, selectTypeDate,
      fromDate, toDate, isOpen, action, userRole, mobilePhoneInputError, userEdit,
      filterError,
    } = this.state;
    const { getProfile, getUsers } = this.props;

    if (!getProfile || !getUsers.data) {
      return <Loading />;
    }

    return (
      <div className="UserManagement layout-box-page">
        <div className="tool-bar">
          <div className="box-filter">
            <InputWithIcon
              id="search-user"
              template="b"
              value={nameInput ? nameInput : mobilePhoneInput}
              icon="fas fa-search"
              placeholder="ค้นหาจากชื่อ / เบอร์โทร"
              onKeyPress={this.handleKeyPress}
              onChange={this.handleInput}
              warning={mobilePhoneInputError || filterError}
              warningText={mobilePhoneInputError ? 'กรุณาใส่เบอร์โทรให้ถูกต้อง' : filterError ? 'คำค้นหาซ้ำ' : null}
            />
            <span className="label-date">Date created</span>
            <DatePicker
              id="filter-date"
              placeholder="เลือกช่วงเวลา"
              selectType={selectTypeDate}
              fromDate={fromDate}
              toDate={toDate}
              handleSelectDate={this.handleSelectDate}
              allDay
            />
          </div>
          <div className="box-export">
            <Button
              className="btn-primary btn-excel"
              onClick={() => this.handleDisplayModal(commonConstant.userManagementCreate, null)}
              id="user-management-create-user"
            >
              <span className="fa fa-user-plus" />
              เพิ่มผู้ใช้งาน
            </Button>
          </div>
        </div>
        <Badges items={filter} handleRemove={this.handleRemoveFilter} hr />
        <div className="box-tabs">
          <span
            className={`tab${userRole ? '' : ' active'}`}
            onClick={() => this.handleSelectUserRole(null)}
            id="user-management-type-all"
          >
            All
          </span>
          <span
            className={`tab${this.handleActiveType(commonConstant.userRoleCashier)}`}
            onClick={() => this.handleSelectUserRole(commonConstant.userRoleCashier)}
            id="user-management-type-cashier"
          >
            Cashier
          </span>
          <span
            className={`tab${this.handleActiveType(commonConstant.userRoleAccounting)}`}
            onClick={() => this.handleSelectUserRole(commonConstant.userRoleAccounting)}
            id="user-management-type-accounting"
          >
            Accounting
          </span>
          <span
            className={`tab${this.handleActiveType(commonConstant.userRoleOperation)}`}
            onClick={() => this.handleSelectUserRole(commonConstant.userRoleOperation)}
            id="user-management-type-operation"
          >
            Operation
          </span>
        </div>
        <div className="table-section">
          <div className="detail-text">
            Total
            <span className="green" id="table-total-users">
              {(getUsers.metadata.pagination.totalRecords ? getUsers.metadata.pagination.totalRecords : 0).toLocaleString()}
            </span>
            accounts
          </div>
          <Table
            id="table-user-management"
            columnHeader={columnHeader}
            data={getUsers.data}
            passFuncBody={this.passFuncBody}
            maxData={getUsers.metadata.pagination.totalRecords >= 0 ? getUsers.metadata.pagination.totalRecords : getUsers.data.length}
            pageSize={pageSize}
            pageNumber={pageNumber}
            handlePageChange={this.handlePageChange}
            sort={sort}
            isSort
            handleSort={this.handleSort}
            handlePageSize={this.handlePageSize}
            filter={filter}
            objToPassFuncBody={{
              'isSuperAdmin': isSuperAdmin(getProfile),
            }}
            passFuncClick={this.function}
            fadeDeletedField
            highlightNewCreatedField
          />
        </div>
        {isOpen ? <UserManage show={isOpen} handleCloseModal={this.handleCloseModal} action={action} userEdit={userEdit} /> : null}
      </div>
    );
  }
}

UserManagement.propTypes = {
  'getProfile': PropTypes.object,
  'match': PropTypes.shape({
    'params': PropTypes.shape({
      'buildingID': PropTypes.string,
      'buildingRefNo': PropTypes.string,
    }),
    'url': PropTypes.string,
  }),
  'getBuildingByRefNo': PropTypes.object,
  'dispatch': PropTypes.func,
  'getUsers': PropTypes.object,
  'createUser': PropTypes.object,
  'updateUser': PropTypes.object,
};

const mapStateToProps = ({ getProfile, getUsers, createUser, updateUser }) => ({
  'getProfile': getProfile.data,
  getUsers,
  createUser,
  updateUser,
});


export default connect(mapStateToProps)(UserManagement);
